import type { ReactNode } from 'react';
import styles from './hug-content-footer.module.css';

type P = {
  children?: ReactNode;
};

const HugContentFooter = ({ children }: P) => <div className={styles['hug-content-footer']}>{children}</div>;

export default HugContentFooter;
